<template>
  <CSidebar
    fixed
    :minimize="minimizeDesktop"
    :show="show"
    class="panel-sidebar"
    dropdownMode="closeInactive"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <div class="panel-sidebar__brand">
      <div class="panel-sidebar__brand-main">
        <CImg
          id="logo_image"
          class="panel-sidebar__logo"
          :src="logo_image"
          width="auto"
          height="32"
        />
        <span id="company_name" class="panel-sidebar__name">فروشگاه</span>
      </div>
      <button type="button" class="panel-sidebar__icon-btn d-md-down-none" :title="minimize ? 'باز کردن منو' : 'جمع کردن منو'"
              @click="$store.commit('set', ['sidebarMinimize', !minimize])">
        <CIcon name="iconSidebar"/>
      </button>
      <button type="button" class="panel-sidebar__icon-btn d-lg-none" title="بستن منو" @click="closeMobile">
        <CIcon name="iconClose"/>
      </button>
    </div>

    <div class="panel-sidebar__profile">
      <img class="panel-sidebar__avatar" :src="user_image" alt="" @error="user_image = '/img/user.png'"/>
      <div class="panel-sidebar__who">
        <strong>{{ user_name || 'مدیر' }}</strong>
        <small><i class="panel-sidebar__online"></i>آنلاین</small>
      </div>
      <button type="button" class="panel-sidebar__icon-btn" title="مشاهده سایت" @click="openSite">
        <CIcon name="iconExternal"/>
      </button>
    </div>

    <div class="panel-sidebar__tools">
      <button
        type="button"
        class="panel-sidebar__icon-btn"
        :title="theme === 'dark' ? 'تم روشن' : 'تم تاریک'"
        @click="$store.commit('toggleTheme')"
      >
        <CIcon v-if="theme === 'dark'" name="iconSun"/>
        <CIcon v-else name="iconMoon"/>
      </button>
      <button type="button" class="panel-sidebar__icon-btn" title="خالی کردن کش" @click="clearCache">
        <CIcon name="iconRefresh"/>
      </button>
      <button type="button" class="panel-sidebar__icon-btn" title="پروفایل" @click="$router.push('/dashboard/users/profile')">
        <CIcon name="iconUser"/>
      </button>
      <button type="button" class="panel-sidebar__icon-btn" title="خروج" @click="logout">
        <CIcon name="iconLogout"/>
      </button>
    </div>

    <div class="panel-sidebar__search">
      <CIcon name="iconSearch" class="panel-sidebar__search-icon"/>
      <input v-model="nav_query" type="search" placeholder="جستجو در منو..." @input="filterNav" @keydown.esc="nav_query = ''; filterNav()"/>
    </div>

    <div class="panel-sidebar__label">ناوبری</div>

    <CRenderFunction ref="sidebar_ref" flat :content-to-render="generate_nav"/>
    <div class="panel-sidebar__empty" v-if="nav_query && nav_no_result">موردی یافت نشد</div>
  </CSidebar>
</template>

<script>
import nav from './_nav'
import axios from 'axios'

export default {
  name: 'TheSidebar',
  nav,
  data() {
    return {
      branch_name: localStorage.getItem("branchName"),
      sidebar_changer: null,
      side_bar_drop_downs: null,
      opened_drop_downs: '',
      logo_image: localStorage.getItem("logo_url") ? localStorage.getItem("logo_url") : '/img/panel_icon.png',
      isNarrow: false,
      nav_query: '',
      nav_no_result: false,
      user_name: localStorage.getItem('user_name') || '',
      user_image: localStorage.getItem('user_image') || '/img/user.png'
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    },
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    minimizeDesktop() {
      if (this.isNarrow) return false
      return this.minimize
    },
    generate_nav() {
      var out_pot = nav;
      let permissions = localStorage.getItem("permissions");
      for (var oo = out_pot[0]._children.length - 1; oo >= 0; oo--) {
        var val = out_pot[0]._children[oo]
        var val_index = oo;

        if (val.items != null) {
          for (var xz = val.items.length - 1; xz >= 0; xz--) {
            var val_item = val.items[xz];
            if (val_item.role != null && !permissions.includes(val_item.role)) {
              val.items.splice(xz, 1);
            } else if (val_item.role_access != null && !this.get_access(val_item.role_access)) {
              val.items.splice(xz, 1);
            }
          }
        }
        if (val.role_access != null && !this.get_access(val.role_access)) {
          out_pot[0]._children.splice(val_index, 1);
        }
        if (val.role != null && !permissions.includes(val.role)) {
          out_pot[0]._children.splice(val_index, 1);
        }
      }
      // presentation-only badges
      out_pot[0]._children.forEach((it) => {
        if (it.to === '/dashboard/media' && !it.badge) it.badge = {color: 'info', text: 'جدید'};
        if (it.to === '/dashboard/ai-seo' && !it.badge) it.badge = {color: 'success', text: 'AI'};
      });
      return out_pot;
    },
  },
  mounted() {
    var self = this;
    this.updateNarrow()
    window.addEventListener('resize', this.updateNarrow)

    this.side_bar_drop_downs = this.$refs['sidebar_ref'].$children[0].$children[0].$children
    this.sidebar_changer = this.$refs['sidebar_ref'].$el;
    var CLASS_NAME_ACTIVE = 'c-active';

    var SELECTOR_NAV_LINK = '.c-xhr-link, .c-sidebar-nav-link';
    var SELECTOR_NAV_ITEM = '.c-sidebar-nav-item';
    this.$router.afterEach((to) => {
      if (window.innerWidth < 992) {
        this.$store.commit('closeSidebarMobile')
      }
      setTimeout(() => {
        Array.from(document.querySelectorAll(SELECTOR_NAV_LINK)).forEach(element => {
          element.classList.remove(CLASS_NAME_ACTIVE)
        })
        Array.from(document.querySelectorAll(`${SELECTOR_NAV_ITEM} a[href="${to.path}"]`)).forEach(element => {
          element.classList.add(CLASS_NAME_ACTIVE)
        })
      }, 500);
    })

    for (var i = 0; i < this.side_bar_drop_downs.length; i++) {
      this.side_bar_drop_downs[i].$el.getElementsByTagName('a')[0].addEventListener('click', function () {
        for (var z = 0; z < self.side_bar_drop_downs.length; z++) {
          if (self.side_bar_drop_downs[z].$el.classList.contains("c-show")) {
            self.side_bar_drop_downs[z].$el.classList.remove("c-show");
          }
        }
        if (self.opened_drop_downs != this.parentElement) {
          self.opened_drop_downs = this.parentElement;
          this.parentElement.classList.add("c-show");
          var sidenav = this.parentElement.parentElement;
          try {
            const lastChild = this.parentElement.getElementsByTagName('ul')[0].getElementsByTagName('li')[this.parentElement.getElementsByTagName('ul')[0].getElementsByTagName('li').length - 1];
            const lastChildRect = lastChild.getBoundingClientRect();
            const lastChildBottom = lastChildRect.bottom;
            const sidenavHeight = sidenav.getBoundingClientRect().bottom;

            if (lastChildBottom > sidenavHeight) {
              setTimeout(function () {
                sidenav.scroll({
                  top: lastChildBottom - sidenavHeight + 100,
                  behavior: 'smooth'
                });
              }, 150);
            }
          } catch (e) {
          }
        } else {
          self.opened_drop_downs = "";
          var sidenav2 = this.parentElement.parentElement;
          sidenav2.scroll({
            top: -500,
            behavior: 'smooth'
          });
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateNarrow)
  },
  methods: {
    // Live filter of the rendered sidebar menu (presentation only).
    filterNav() {
      const root = this.$refs.sidebar_ref && this.$refs.sidebar_ref.$el;
      if (!root) return;
      const q = (this.nav_query || '').trim().toLowerCase();
      let any = false;
      const text = (el) => (el.textContent || '').trim().toLowerCase();
      root.querySelectorAll(':scope > li, .c-sidebar-nav > li').forEach((li) => {
        if (li.parentElement && li.parentElement.classList.contains('c-sidebar-nav-dropdown-items')) return;
        if (!q) { li.style.display = ''; li.querySelectorAll('li').forEach((c) => { c.style.display = ''; }); if (li._navOpened) { li.classList.remove('c-show'); li._navOpened = false; } return; }
        const toggle = li.querySelector(':scope > a');
        const own = toggle ? text(toggle) : text(li);
        const kids = li.querySelectorAll('.c-sidebar-nav-dropdown-items > li');
        let kidHit = false;
        kids.forEach((c) => {
          const hit = own.indexOf(q) >= 0 || text(c).indexOf(q) >= 0;
          c.style.display = hit ? '' : 'none';
          if (text(c).indexOf(q) >= 0) kidHit = true;
        });
        const show = own.indexOf(q) >= 0 || kidHit;
        li.style.display = show ? '' : 'none';
        if (show) any = true;
        if (kids.length && kidHit && !li.classList.contains('c-show')) { li.classList.add('c-show'); li._navOpened = true; }
      });
      this.nav_no_result = !!q && !any;
    },    updateNarrow() {
      this.isNarrow = window.innerWidth < 992
      if (this.isNarrow && this.minimize) {
        this.$store.commit('set', ['sidebarMinimize', false])
      }
    },
    closeMobile() {
      this.$store.commit('closeSidebarMobile')
    },
    openSite() {
      window.open(localStorage.getItem("site_url"))
    },
    logout() {
      localStorage.setItem('token', '')
      this.$router.push({ path: '/dashboard/login' })
    },
    clearCache() {
      axios.post('/api/admin/site/clear_cache', new FormData(), {})
        .then((response) => {
          if (this.$root.modal_component) {
            this.$root.modal_component.show_api_response_modals(response)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    scroll_sidebar() {
    }
  },
  watch: {
    'sidebar_changer': function () {
    }
  }
}
</script>
